export const PANEL_TYPE = 'Artifacts panel grid';

export type ArtifactVersionMetricChartType = 'bar' | 'line' | 'scatter';

export type ArtifactVersionMetricXAxisMode = 'selectionIndex';

export interface ArtifactVersionMetricPanelConfig {
  membershipIds: string[];
  metricName?: string;
  /** Scatter only: metric plotted on the x axis (e.g. loss vs accuracy). */
  xMetricName?: string;
  chartType?: ArtifactVersionMetricChartType;
  xAxisMode: ArtifactVersionMetricXAxisMode;
  /** Bar chart only: render vertical bars instead of the default horizontal. */
  barVertical?: boolean;
  chartTitle?: string | null;
  yAxisMin?: number | null;
  yAxisMax?: number | null;
  yLogScale?: boolean;
  /** Scatter only: x-axis range overrides (x axis is otherwise version-derived). */
  xAxisMin?: number | null;
  xAxisMax?: number | null;
  xLogScale?: boolean;
}

export interface ArtifactVersionMetricChartRow {
  membershipId: string;
  selectionIndex: number;
  label: string;
  value: number | null;
  versionIndex?: number | null;
  aliases: string[];
  historyStep?: number | null;
  sourceRunName?: string | null;
  sourceProjectName?: string | null;
}

export const INITIAL_CONFIG: ArtifactVersionMetricPanelConfig = {
  membershipIds: [],
  metricName: undefined,
  xAxisMode: 'selectionIndex',
};
